import { render, staticRenderFns } from "./orderRemind.vue?vue&type=template&id=398077b6&scoped=true"
import script from "./orderRemind.vue?vue&type=script&lang=js"
export * from "./orderRemind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398077b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398077b6')) {
      api.createRecord('398077b6', component.options)
    } else {
      api.reload('398077b6', component.options)
    }
    module.hot.accept("./orderRemind.vue?vue&type=template&id=398077b6&scoped=true", function () {
      api.rerender('398077b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/component/orderRemind.vue"
export default component.exports